import axios from "axios";

const configuredApiBase = process.env.REACT_APP_NOT_SECRET_CODE || "";
const rfqApiBase = configuredApiBase;

const headers = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

const uploadHeaders = (token) => {
  const requestHeaders = {
    "X-Request-ID": "124",
    "X-Country-Code": "BD",
    "X-Client-Name": "WEBSITE",
    "X-Client-Version": "123",
  };

  if (token) {
    requestHeaders.Authorization = "Bearer " + token;
  }

  return requestHeaders;
};

const unwrapApiResponse = (res) => {
  const payload = res.data;

  if (payload && payload.success === false) {
    const error = new Error(payload.message || "Request failed.");
    error.response = { data: payload };
    throw error;
  }

  return payload;
};

export const getRfqRequests = (token, page = 1, filters = {}) => {
  return axios
    .get(`${rfqApiBase}/rfq-requests`, {
      params: {
        page,
        records_per_page: filters.records_per_page || filters.per_page || "",
        status: filters.status || "",
        b2b_id: filters.b2b_id || "",
        source_type: filters.source_type || "",
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const parseRfqLines = (token, rawText) => {
  return axios
    .post(
      `${rfqApiBase}/rfq-requests/parse-lines`,
      { raw_text: rawText },
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const importRfqDocument = (
  token,
  file,
  b2bId = null,
  leadId = null,
  options = {},
) => {
  const formData = new FormData();
  formData.append("document", file);
  if (b2bId) formData.append("b2b_id", b2bId);
  if (leadId) formData.append("lead_id", leadId);
  if (options.forceAi) formData.append("force_ai", "1");

  return axios
    .post(`${rfqApiBase}/rfq-requests/import-document`, formData, {
      headers: uploadHeaders(token),
    })
    .then(unwrapApiResponse);
};

export const createRfqRequest = (token, payload) => {
  return axios
    .post(`${rfqApiBase}/rfq-requests`, payload, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const updateRfqRequest = (token, id, payload) => {
  return axios
    .put(`${rfqApiBase}/rfq-requests/${id}`, payload, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getRfqRequest = (token, id) => {
  return axios
    .get(`${rfqApiBase}/rfq-requests/${id}`, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const deleteRfqRequest = (token, id) => {
  return axios
    .delete(`${rfqApiBase}/rfq-requests/${id}`, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const downloadRfqQuotationPdf = (token, id) => {
  return axios.get(
    `${rfqApiBase}/rfq-requests/${id}/quotation-pdf`,
    {
      headers: headers(token),
      responseType: "blob",
    },
  );
};

export const selectRfqMatch = (token, itemId, matchId) => {
  return axios
    .post(
      `${rfqApiBase}/rfq-request-items/${itemId}/matches/${matchId}/select`,
      {},
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const assignRfqMedication = (token, itemId, payload) => {
  return axios
    .post(
      `${rfqApiBase}/rfq-request-items/${itemId}/assign-medication`,
      payload,
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const updateRfqOutcome = (token, itemId, payload) => {
  return axios
    .post(
      `${rfqApiBase}/rfq-request-items/${itemId}/outcome`,
      payload,
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const searchRfqMedications = (token, query, b2bId = null, leadId = null) => {
  return axios
    .get(`${rfqApiBase}/rfq-medications/search`, {
      params: {
        query,
        b2b_id: b2bId || "",
        lead_id: leadId || "",
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const enrichRfqLines = (token, lines, b2bId = null, leadId = null) => {
  return axios
    .post(
      `${rfqApiBase}/rfq-medications/enrich-lines`,
      {
        lines,
        b2b_id: b2bId || "",
        lead_id: leadId || "",
      },
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const learnRfqLineMapping = (token, payload) => {
  return axios
    .post(`${rfqApiBase}/rfq-line-mappings/learn`, payload, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getRfqMedicationCatalogue = (token, storeId) => {
  return axios
    .get(`${rfqApiBase}/medications/all`, {
      params: {
        store: storeId,
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getRfqMedicationStock = (token, medicationId, storeId) => {
  return axios
    .get(`${rfqApiBase}/storewise/medicationall/${medicationId}`, {
      params: {
        store_id: storeId,
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const createRfqDraftOrder = (token, id) => {
  return axios
    .post(
      `${rfqApiBase}/rfq-requests/${id}/draft-order`,
      {},
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const searchRfqB2bClients = (token, companyName = "") => {
  return axios
    .get(`${rfqApiBase}/leads`, {
      params: {
        search_subscriber: companyName,
        records_per_page: 15,
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const searchRfqQuotationReps = (token, search = "") => {
  return axios
    .get(`${rfqApiBase}/rfq-quotation-reps`, {
      params: {
        search,
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getRfqClientOrderHistory = (token, b2bName = "") => {
  return axios
    .get(`${rfqApiBase}/orders`, {
      params: {
        name: " ",
        status: "",
        source: "",
        rider_id: "",
        order_date: "",
        payment_type: "",
        b2b: b2bName,
        channel: "",
        order_id: "",
        po_number: "",
        from_date: "",
        to_date: "",
        page: 1,
        city_id: 0,
        order_type: "",
        is_courier_partner: 0,
        sales_user_id: "",
        order_sub_type: 2,
        partial_sent: "",
        is_claimable: 0,
        store: "",
        store_id: "",
        delivery_type: "",
        total_cost_from: "",
        total_cost_to: "",
      },
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getRfqClientOrderDetail = (token, orderId) => {
  return axios
    .get(`${rfqApiBase}/orders/${orderId}`, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};
